import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import ValueDimensionsCard from './ValueDimensionsCard';
import ChallengeFactorsCard from './ChallengeFactorsCard';

const WeightSelection = () => {
  const { weights, setWeights } = useAssessment();

  const handleWeightChange = (key: keyof typeof weights, value: number[]) => {
    setWeights({ ...weights, [key]: value[0] });
  };

  return (
    <div className="container mx-auto py-8 sm:py-12 px-4 w-full max-w-[1600px]">
      <div className="text-center space-y-4">
        <div className="inline-block px-5 py-2 text-lg font-medium text-white bg-gradient-to-r from-[#CA0079] to-[#F1AB11] rounded-full shadow-lg font-geist-mono mb-4">
          OPPORTUNITY ASSESSMENT
        </div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl text-gray-800 pb-4 font-medium">
          Discover where AI can make the biggest impact
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-5xl mx-auto font-light pb-6 sm:pb-8">
        Tell us about your jurisdiction's goals and challenges, and we'll recommend AI solutions that can
        simplify, streamline, and strengthen your operations. 
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 mt-6 sm:mt-8">
        <div className="h-full">
          <ValueDimensionsCard weights={weights} onWeightChange={handleWeightChange} />
        </div>
        <div className="h-full">
          <ChallengeFactorsCard weights={weights} onWeightChange={handleWeightChange} />
        </div>
      </div>
    </div>
  );
};

export default WeightSelection;